import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import Heading from 'components/Basic/Heading/Heading';
import CommonLayout from 'components/Layout/CommonLayout';
import Webline from 'components/Layout/Webline/Webline';
import { useDomainConfig } from 'hooks/useDomainConfig';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';

export const Error403 = () => {
    const { t } = useTranslation();
    const { url: homepageUrl } = useDomainConfig();

    return (
        <CommonLayout
            title={t('Something wrong happened... You do not have sufficient permissions')}
            withoutMoveUpActionButton
        >
            <Webline>
                <div className="flex flex-col items-center pt-14 pb-14">
                    <Heading type="h1">{t('You do not have sufficient permissions')}</Heading>
                    <Heading type="h6">
                        {t('We are sorry, but you do not have sufficient permissions to view this page.')}
                    </Heading>
                    <div className="leading-6 text-grayVeryDark">
                        {t('You are looking for a page that requires authorization, you may need to be logged in.')}
                    </div>
                    <div className="leading-6 text-grayVeryDark">
                        <Trans
                            i18nKey="Error403LoginOrHomepage"
                            components={{
                                link: (
                                    <ExtendedNextLink type="static" href="/">
                                        {homepageUrl}
                                    </ExtendedNextLink>
                                ),
                            }}
                        />
                    </div>
                </div>
            </Webline>
        </CommonLayout>
    );
};
